import {Accordion, AccordionDetails, AccordionSummary, Box} from '@mui/material';
import {useState} from "react";

import {Title, SubTitle, TextInfo, ImgsWrapper, ImgContent, ImgCertificate} from './Certificates.styles'
import FastButton from "../../../../shared/FastButton";
import FastIcon from "../../../../shared/FastIcon";
import {profileService} from "../../../../services/profile.service";


const Certificates = ({info}: any) => {
    const [expandedOne, setExpandedOne] = useState(true)
    const [expandedTwo, setExpandedTwo] = useState(true)
    const [files, setFiles] = useState<any[]>(info.certificates)


    function toDataURL(url: any, callback: any) {
        let xhr = new XMLHttpRequest();
        xhr.onload = function () {
            let reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    function getFiles(e: any) {
        toDataURL(URL.createObjectURL(e.target.files[0]), function (dataUrl: string) {
            profileService.uploadCertificate({file: dataUrl}).then((data: any) => {
                setFiles([...files, data.data]);
            })
        })
    }

    function deleteCertificate(id: string) {
        profileService.deleteCertificate(id).then(() => {
            setFiles(files.filter((item) => id !== item.id))
        })
    }


    return <Box>
        <Accordion sx={{border: "none", boxShadow: 'none'}} expanded={expandedOne}>
            <AccordionSummary
                expandIcon={<FastIcon name={'arrow'}/>}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={{flexDirection: 'row-reverse'}}
            >
                <Title onClick={() => setExpandedOne(!expandedOne)}>Сертификаты HiStudy</Title>
            </AccordionSummary>
            <AccordionDetails
            >
                <SubTitle>У вас пока нет сертификатов</SubTitle>
                <TextInfo>Перейти к выбору курса?</TextInfo>
                <FastButton title={'Перейти на главную'} variant="contained"
                            sx={{fontSize: '16px', padding: '11px 16px'}}/>
            </AccordionDetails>
        </Accordion>
        <Accordion sx={{
            border: "none", boxShadow: 'none', ' :before': {
                display: 'none'
            }
        }} expanded={expandedTwo}>
            <AccordionSummary
                expandIcon={<FastIcon name={'arrow'}/>}
                aria-controls="panel2a-content"
                id="panel2a-header"
                sx={{flexDirection: 'row-reverse'}}
            >
                <Box sx={{display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center'}}>
                    <Title
                        onClick={() => setExpandedTwo(!expandedTwo)}>Другие сертификаты </Title>
                    {files.length ? <FastButton typeBtn='file' title={'Загрузить'} variant="contained" accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
                    text/plain, application/pdf, image/*"
                                                sx={{fontSize: '16px', padding: '11px 16px'}} onChange={(e: any) => {
                        getFiles(e)
                    }}/> : null}</Box>

            </AccordionSummary>
            <AccordionDetails>
                {files.length ? <ImgsWrapper>
                    {files.map(el => {
                        return <ImgContent key={el.id}>
                            <FastIcon name={'trash'} sx={{position: 'absolute', top: '12px', right: '12px'}}
                                      onClick={() => {
                                          deleteCertificate(el.id)
                                      }
                                      }/>
                            <ImgCertificate src={el.file_path}/></ImgContent>
                    })}
                </ImgsWrapper> : <>  <SubTitle>У вас пока нет сертификатов</SubTitle>
                    <TextInfo>Загрузите другие сертификаты</TextInfo>
                </>}
                {!files.length ? <FastButton typeBtn='file' title={'Загрузить'} variant="contained" accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
                    text/plain, application/pdf, image/*"
                                             sx={{fontSize: '16px', padding: '11px 16px'}} onChange={(e: any) => {
                    getFiles(e)
                }}/> : null}

            </AccordionDetails>
        </Accordion>
    </Box>
}
export default Certificates
